import { CSSProperties, FC } from 'react';
import { AccountProject } from './permissions-table.types';
import { TableCell, TextBody } from '@pypestream/design-system';
import './permissions-table.scss';

export const ProjectNameCell: FC<{
  project: AccountProject;
}> = ({ project }) => (
  <TableCell
    rowspan={project.project?.project_product_settings?.length || 1}
    style={{ '--c-table-cell-min-width': '120px' } as CSSProperties}
  >
    <TextBody variant="secondary" size="small">
      {project?.project.name}
    </TextBody>
  </TableCell>
);
